import React, { useEffect } from "react";
import TheoryCorrectionAdmin from "../../components/APanel/TheoryCorrectionAdmin";

export default function APTheoryCorrection() {
   useEffect(() => {
      document.title = "Instruire Auto | Corectare teorie";
   }, []);

   return (
      <main className="main">
         <TheoryCorrectionAdmin />
      </main>
   );
}
